import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/taurusx_logo.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "item logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "item title text" }, "36 Robinson Rd, Singapore 06887", -1)
const _hoisted_3 = { class: "item title text" }
const _hoisted_4 = { style: {"font-weight":"700"} }
const _hoisted_5 = { class: "item overall" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "title text" }, "Overall", -1)
const _hoisted_7 = {
  key: 0,
  style: {"text-align":"right"}
}
const _hoisted_8 = {
  key: 1,
  style: {"text-align":"right"}
}
const _hoisted_9 = {
  key: 2,
  style: {"text-align":"right"}
}
const _hoisted_10 = {
  key: 3,
  style: {"text-align":"right"}
}
const _hoisted_11 = { style: {"text-align":"right"} }
const _hoisted_12 = {
  key: 0,
  style: {"text-align":"right"}
}
const _hoisted_13 = {
  key: 1,
  style: {"text-align":"right"}
}
const _hoisted_14 = {
  key: 2,
  style: {"text-align":"right"}
}
const _hoisted_15 = {
  key: 3,
  style: {"text-align":"right"}
}
const _hoisted_16 = { class: "item statement" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "title text" }, "Statement", -1)
const _hoisted_18 = {
  class: "statement_table",
  style: { 'table-layout': 'fixed' }
}
const _hoisted_19 = {
  key: 0,
  class: "sum"
}
const _hoisted_20 = ["colspan"]
const _hoisted_21 = {
  key: 0,
  style: {"text-align":"right"}
}
const _hoisted_22 = {
  key: 1,
  style: {"text-align":"right"}
}
const _hoisted_23 = ["rowspan"]
const _hoisted_24 = ["src"]
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "item footer text" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" 返回修改 ")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("仅生成对账单")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("生成&发送邮件")

import { get_company_item } from '@/api/crm-customer';
  import { add_scaler_billing_pdf } from '@/api/erp-bills';
  import { DialogConfig, DialogFormItem } from '@/components/WeDialog/types';
  import { useApp } from '@/hooks/useApp';
  import { useAppInfo } from '@/hooks/useAppInfo';
  import { appStore } from '@/store/modules/app';
  import { outPutPdf } from '@/utils/canvas_to_pdf';
  import {
    copyObjectToReactive,
    getFileType,
    isImage,
    formatNumberByNumeral,
    groupBy,
    mergeRowsByProperty,
  } from '@/utils/common';
  import { isProd } from '@/utils/const';

  import { required } from '@/utils/validate';
  import sortBy from 'lodash-es/sortBy';
  import { computed, reactive, ref } from 'vue';

  interface IProps {
    bill: Recordable;
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    bill: { default: () => ({}) }
  },
  emits: ['generate_done', 'generate_done_send'],
  setup(__props: any, { expose, emit }) {

const props = __props as { bill: Recordable }

  const init_company_form = {
    company_name: '',
    company_address: '',
    month: '',
    fields_show: [],
    attach_files: [],
    upload_attach_files: [],
    scaler_email: '',
  };

  

  const { $showDialog } = useApp();
  const { apiRoot } = useAppInfo();

  

  const visible = ref(false);
  const thead_list = ref<any>([]);
  const attach_files_list = ref<Recordable[]>([]);
  const data_source = ref<Recordable[]>([]);
  const content_width = ref(1000);
  const padding = ref(24);
  const loading = ref(false);
  const only_loading = ref(false);
  const company_form = reactive<Recordable>(init_company_form);

  const all_billing_money_sum = computed(() => {
    return data_source.value.reduce((pre, cur) => {
      pre = pre + cur.billing_money;
      return pre;
    }, 0);
  });
  const billing_money_sum = computed(() => {
    if (thead_list.value.find((f) => f.label === '结算金额')) {
      return formatNumberByNumeral(all_billing_money_sum.value, '0,0.00');
    }
    return null;
  });
  const real_install_sum = computed(() => {
    if (thead_list.value.find((f) => f.label === '真实转化数')) {
      return formatNumberByNumeral(
        data_source.value.reduce((pre, cur) => {
          pre = pre + cur.real_install;
          return pre;
        }, 0),
        '0,0'
      );
    }
    return null;
  });
  const need_sum_columns = computed(() => {
    return thead_list.value.filter((f) => ['结算金额', '真实转化数'].includes(f.label));
  });
  const get_deduction_money = computed(() => {
    let value = 0;
    if (props.bill.billing && props.bill.billing.adjust_list) {
      value = props.bill.billing.adjust_list.reduce((pre, cur) => {
        if (cur.adjust_money < 0 && cur.adjust_type === '核减') {
          pre = pre + cur.adjust_money;
        }
        return pre;
      }, 0);
    }
    return value;
  });
  const get_adjustment_money = computed(() => {
    let value = 0;
    if (props.bill.billing && props.bill.billing.adjust_list) {
      value = props.bill.billing.adjust_list.reduce((pre, cur) => {
        if (cur.adjust_money > 0 && cur.adjust_type === '增加') {
          pre = pre + cur.adjust_money;
        }
        return pre;
      }, 0);
    }
    return value;
  });
  const get_tax_money = computed(() => {
    let value = 0;
    if (props.bill.billing && props.bill.billing.adjust_list) {
      value = props.bill.billing.adjust_list.reduce((pre, cur) => {
        if (cur.adjust_money > 0 && cur.adjust_type === '增加（税额）') {
          pre = pre + cur.adjust_money;
        }
        return pre;
      }, 0);
    }
    return value;
  });
  const td_width = computed(() => {
    const thead_list_length = thead_list.value.length;
    if (thead_list_length) {
      let total_width = content_width.value;
      const find_country_item = thead_list.value.find((f) => f.value === 'country');
      const find_publisher_item = thead_list.value.find((f) => f.value === 'publisher');
      if (find_country_item) {
        total_width = total_width - find_country_item.width;
      }
      if (find_publisher_item) {
        total_width = total_width - find_publisher_item.width;
      }
      return `${total_width / thead_list_length}px`;
    } else {
      return 0;
    }
  });

  function reset_company_form() {
    copyObjectToReactive(company_form, init_company_form);
  }
  function get_file(id) {
    const find_item = attach_files_list.value.find((f) => f.id === id);
    if (find_item) {
      const url = `${apiRoot.value}/get_entity_file/?entity_file_id=${find_item.id}&entity_id=${props.bill.flow_id}&entity_type=flow`;
      return url;
    }
    return '';
  }
  async function show_generate_bill_dialog() {
    const fields_show = [
      {
        label: '广告主名称',
        value: 'company_short_name',
        en_label: 'Advertiser',
        textAlign: 'left',
      },
      {
        label: '账户名称',
        value: 'agency_name',
        en_label: 'Account Name',
        textAlign: 'left',
      },
      {
        label: '产品包名',
        value: 'adv_bundle',
        en_label: 'App Bundle',
        textAlign: 'left',
        width: 200,
      },
      {
        label: '产品名称',
        value: 'adv_name',
        en_label: 'App Name',
        textAlign: 'left',
      },

      {
        label: 'Campaign',
        value: 'camp_name',
        en_label: 'Campaign Name',
        textAlign: 'left',
      },
      {
        label: '地区',
        value: 'country',
        en_label: 'Region',
        textAlign: 'left',
        width: 50,
      },
      {
        label: '真实转化数',
        value: 'real_install',
        en_label: 'Conversions',
        textAlign: 'right',
      },
      {
        label: '结算金额',
        value: 'billing_money',
        en_label: `Cost(USD)`,
        textAlign: 'right',
      },
    ];
    let attach_files_items: Recordable[] = [];
    props.bill.flow &&
      props.bill.flow.state_list.forEach((item) => {
        attach_files_items.push(...item.file_list.filter((f) => isImage(getFileType(f.file_name))));
      });
    attach_files_items = attach_files_items.map((item) => ({ ...item, label: item.file_name, value: item.id }));
    attach_files_list.value = attach_files_items;
    if (!company_form.company_name) {
      const res = await get_company_item({ company_id: props.bill.company_id });
      company_form.company_name = res.company.name;
      company_form.company_address = res.company.invoice_address;
    }
    // data_source.value = Array(80).fill(props.bill.billing.billing_list[0]);
    function get_data_source() {
      let list = props.bill.billing.billing_list
        .filter((f) => Number(f.billing_money) !== 0)
        .map((m) => ({
          publisher: 'TaurusX',
          ...m,
        }));
      function getGroupByKey() {
        return thead_list.value.filter((m) => !['real_install', 'billing_money'].includes(m.value)).map((m) => m.value);
      }
      let final_list: Recordable[] = [];

      const key = getGroupByKey();
      let key_result = key as string[];
      if (key) {
        if (typeof key === 'string') {
          key_result = [key];
        }
        const groupByObj = groupBy(list, key_result);
        Object.keys(groupByObj).forEach((f) => {
          final_list.push({
            ...groupByObj[f][0],
            ...groupByObj[f].reduce(
              (pre, cur) => {
                pre.real_install += cur.real_install;
                pre.billing_money += cur.billing_money;
                return pre;
              },
              {
                real_install: 0,
                billing_money: 0,
              }
            ),
          });
        });
      } else {
        final_list = list;
      }
      final_list = sortBy(final_list, key_result);
      data_source.value = final_list;
    }
    company_form.month = props.bill.month;
    const inputs: DialogFormItem[] = [
      {
        label: '客户名称',
        result: 'company_name',
        type: 'text',
        rules: [required()],
        width: 24,
      },
      // {
      //   label: '客户地址',
      //   result: 'company_address',
      //   type: 'text',
      //   rules: [required()],
      //   width: 24,
      // },
      {
        label: '业务期间',
        result: 'month',
        type: 'month',
        disabled: true,
        width: 24,
      },
      {
        label: '销售Email',
        result: 'scaler_email',
        type: 'text',
        rules: [required()],
        width: 24,
      },
      {
        label: '结算列表字段',
        result: 'fields_show',
        type: 'check',
        width: 24,
        rules: [required()],
        value: fields_show,
      },
      {
        label: '附件图片',
        result: 'attach_files',
        type: 'check',
        width: 24,
        value: attach_files_items,
      },
    ];
    const dialog_config: DialogConfig = {
      title: '生成对账单',
      blocks: [
        { type: 'input', value: inputs },
        {
          type: 'backend_oss_upload',
          label: '上传图片',
          result: 'upload_attach_files',
          mode: 'multiple',
        },
      ],
      init: company_form,
      okText: '预览/生成对账单',
      callback: (result) => {
        thead_list.value = fields_show.filter((f) => result.fields_show.includes(f.value));
        thead_list.value.unshift({
          label: 'DSP',
          value: 'publisher',
          en_label: 'DSP',
          textAlign: 'left',
          width: 60,
        });
        get_data_source();
        copyObjectToReactive(company_form, {
          ...init_company_form,
          ...result,
        });
        visible.value = true;
        appStore.SET_WE_DIALOG(null);
      },
      cancel: () => {
        reset_company_form();
        appStore.SET_WE_DIALOG(null);
      },
    };
    $showDialog(dialog_config);
  }
  function generate_pdf(is_only_generate_pdf = true) {
    if (is_only_generate_pdf) {
      only_loading.value = true;
    } else {
      loading.value = true;
    }
    const outPutPdfRes = outPutPdf('test', 'generate_bill_pdf')!;
    outPutPdfRes.then((res: any) => {
      const reader = new FileReader();
      reader.readAsDataURL(res);
      reader.onload = function (e) {
        const params = {
          bill_id: props.bill.id,
          data: {
            company_name: company_form.company_name,
            company_address: company_form.company_address,
            fields_show: company_form.fields_show,
            scaler_email: company_form.scaler_email ? company_form.scaler_email : '',
            attach_files: [
              ...company_form.attach_files.map((m) => ({ id: m })),
              ...company_form.upload_attach_files.map((m) => ({ ...m, file_name: m.name })),
            ],
            pdf: e.target?.result,
          },
        };
        add_scaler_billing_pdf(params).then(() => {
          only_loading.value = false;
          loading.value = false;
          visible.value = false;
          appStore.SET_WE_DIALOG(null);
          if (is_only_generate_pdf) {
            emit('generate_done');
          } else {
            emit('generate_done_send');
          }
        });
      };
    });
  }

  expose({
    show_generate_bill_dialog,
  });

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_AModal = _resolveComponent("AModal")!

  return (_openBlock(), _createBlock(_component_AModal, {
    visible: visible.value,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((visible).value = $event)),
    wrapClassName: "bill_pdf_dialog_container",
    width: content_width.value + padding.value * 2,
    maskClosable: "",
    centered: "",
    closable: false,
    afterClose: reset_company_form
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_a_button, {
        onClick: _cache[0] || (_cache[0] = 
          () => {
            visible.value = false;
            show_generate_bill_dialog();
          }
        )
      }, {
        default: _withCtx(() => [
          _hoisted_27
        ]),
        _: 1
      }),
      _createVNode(_component_a_button, {
        type: "primary",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (generate_pdf(true))),
        loading: only_loading.value
      }, {
        default: _withCtx(() => [
          _hoisted_28
        ]),
        _: 1
      }, 8, ["loading"]),
      (!_unref(isProd))
        ? (_openBlock(), _createBlock(_component_a_button, {
            key: 0,
            type: "primary",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (generate_pdf(false))),
            loading: loading.value
          }, {
            default: _withCtx(() => [
              _hoisted_29
            ]),
            _: 1
          }, 8, ["loading"]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        id: "generate_bill_pdf",
        class: "generate_bill_pdf",
        style: _normalizeStyle({ padding: padding.value + 'px' })
      }, [
        _hoisted_1,
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createTextVNode(" Issued to " + _toDisplayString(_unref(company_form).company_name) + " ", 1),
          _createElementVNode("span", _hoisted_4, "(Period:" + _toDisplayString(_unref(company_form).month) + ")", 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("table", {
            class: "statement_table",
            style: _normalizeStyle(__props.bill.billing.all_adjust_money ? { 'table-layout': 'fixed' } : { 'table-layout': 'fixed' })
          }, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", {
                  style: _normalizeStyle(__props.bill.billing.all_adjust_money ? { 'text-align': 'right' } : { 'text-align': 'right' })
                }, " Cost(" + _toDisplayString(__props.bill.rd_currency_name) + ") ", 5),
                (_unref(get_deduction_money))
                  ? (_openBlock(), _createElementBlock("td", _hoisted_7, "Deduction(" + _toDisplayString(__props.bill.rd_currency_name) + ")", 1))
                  : _createCommentVNode("", true),
                (_unref(get_adjustment_money))
                  ? (_openBlock(), _createElementBlock("td", _hoisted_8, "Adjustment(" + _toDisplayString(__props.bill.rd_currency_name) + ")", 1))
                  : _createCommentVNode("", true),
                (_unref(get_tax_money))
                  ? (_openBlock(), _createElementBlock("td", _hoisted_9, "Tax(" + _toDisplayString(__props.bill.rd_currency_name) + ")", 1))
                  : _createCommentVNode("", true),
                (__props.bill.billing.all_adjust_money)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_10, " Payable(" + _toDisplayString(__props.bill.rd_currency_name) + ") ", 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_11, _toDisplayString(_unref(formatNumberByNumeral)(__props.bill.finance_invoice_money - __props.bill.billing.all_adjust_money, '0,0.00')), 1),
                (_unref(get_deduction_money))
                  ? (_openBlock(), _createElementBlock("td", _hoisted_12, _toDisplayString(_unref(formatNumberByNumeral)(0 - _unref(get_deduction_money), '0,0.00')), 1))
                  : _createCommentVNode("", true),
                (_unref(get_adjustment_money))
                  ? (_openBlock(), _createElementBlock("td", _hoisted_13, _toDisplayString(_unref(formatNumberByNumeral)(_unref(get_adjustment_money), '0,0.00')), 1))
                  : _createCommentVNode("", true),
                (_unref(get_tax_money))
                  ? (_openBlock(), _createElementBlock("td", _hoisted_14, _toDisplayString(_unref(formatNumberByNumeral)(_unref(get_tax_money), '0,0.00')), 1))
                  : _createCommentVNode("", true),
                (__props.bill.billing.all_adjust_money)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_15, _toDisplayString(_unref(formatNumberByNumeral)(__props.bill.finance_invoice_money, '0,0.00')), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 4)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("table", _hoisted_18, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(thead_list.value, (item) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: item.label,
                    style: _normalizeStyle({ width: item.width ? item.width + 'px' : _unref(td_width), 'text-align': item.textAlign })
                  }, _toDisplayString(item.en_label), 5))
                }), 128))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_unref(need_sum_columns).length)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                    _createElementVNode("td", {
                      colspan: thead_list.value.length - _unref(need_sum_columns).length,
                      style: {"text-align":"left"}
                    }, "Total", 8, _hoisted_20),
                    (_unref(real_install_sum))
                      ? (_openBlock(), _createElementBlock("td", _hoisted_21, _toDisplayString(_unref(real_install_sum)), 1))
                      : _createCommentVNode("", true),
                    (_unref(billing_money_sum))
                      ? (_openBlock(), _createElementBlock("td", _hoisted_22, _toDisplayString(_unref(billing_money_sum)), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data_source.value, (data, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(thead_list.value, (item) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: item.label
                    }, [
                      (
                    ['adv_name', 'adv_bundle', 'publisher'].includes(item.value) &&
                    _unref(mergeRowsByProperty)(data_source.value, index, item.value)
                  )
                        ? (_openBlock(), _createElementBlock("td", {
                            key: 0,
                            style: _normalizeStyle({ 'text-align': item.textAlign }),
                            rowspan: _unref(mergeRowsByProperty)(data_source.value, index, item.value)
                          }, _toDisplayString(data[item.value]), 13, _hoisted_23))
                        : _createCommentVNode("", true),
                      (!['adv_name', 'adv_bundle', 'publisher'].includes(item.value))
                        ? (_openBlock(), _createElementBlock("td", {
                            key: 1,
                            style: _normalizeStyle({ 'text-align': item.textAlign })
                          }, _toDisplayString(['billing_money', 'real_install'].includes(item.value)
                      ? _unref(formatNumberByNumeral)(data[item.value], 'real_install' === item.value ? '0,0' : '0,0.00')
                      : data[item.value]), 5))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]))
              }), 128))
            ])
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(company_form).attach_files, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item image_div",
            key: index
          }, [
            _createElementVNode("img", {
              src: get_file(item),
              alt: ""
            }, null, 8, _hoisted_24)
          ]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(company_form).upload_attach_files, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item image_div",
            key: index
          }, [
            _createElementVNode("img", {
              src: item.base64_data,
              alt: ""
            }, null, 8, _hoisted_25)
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("span", null, "For Questions about this statement please email " + _toDisplayString(_unref(company_form).scaler_email), 1)
        ])
      ], 4)
    ]),
    _: 1
  }, 8, ["visible", "width"]))
}
}

})